export default __webpack_public_path__ + "static/media/COMM_VERBAL.9be1cb76.pdf";